import React, {useState, useMemo, useEffect} from 'react'
import moment from 'moment'
import _ from 'lodash'

import Month from './Month'

const MonthView = ({
  selectedFromMomentDate,
  selectedToMomentDate,
  onClickDay,
  onClickTime,
  disableDatesBefore,
  disableDatesAfter,
  dateSelection,
  month = moment().startOf('month'),
}) => {
  const [months, setMonths] = useState([month, month.clone().add(1, 'month')])

  // go to from month in selection
  useEffect(() => {
    if (selectedFromMomentDate && dateSelection === 'from') {
      if (
        !months.find(
          f =>
            f.valueOf() ===
            selectedFromMomentDate
              .clone()
              .startOf('month')
              .valueOf()
        )
      ) {
        const month = selectedFromMomentDate.clone().startOf('month')
        setMonths([month, month.clone().add(1, 'month')])
      }
    }
  }, [selectedFromMomentDate, dateSelection, months])

  const handleClickNextMonth = () => {
    setMonths(p => [p[0].add(1, 'month').clone(), p[1].add(1, 'month').clone()])
  }
  const handleClickPrevMonth = () => {
    setMonths(p => [p[0].subtract(1, 'month').clone(), p[1].subtract(1, 'month').clone()])
  }

  return (
    <div style={{display: 'flex'}}>
      <Month
        momentDate={months[0]}
        onClickPrevMonth={handleClickPrevMonth}
        onClickDay={onClickDay}
        onClickTime={onClickTime}
        hideNextMonth
        selectedFromMomentDate={selectedFromMomentDate}
        selectedToMomentDate={selectedToMomentDate}
        disableDatesBefore={disableDatesBefore}
        disableDatesAfter={disableDatesAfter}
        dateSelection={dateSelection}
      />
      <div style={{width: 32}}></div>
      <Month
        momentDate={months[1]}
        onClickNextMonth={handleClickNextMonth}
        onClickDay={onClickDay}
        onClickTime={onClickTime}
        hidePrevMonth
        selectedFromMomentDate={selectedFromMomentDate}
        selectedToMomentDate={selectedToMomentDate}
        disableDatesBefore={disableDatesBefore}
        disableDatesAfter={disableDatesAfter}
        dateSelection={dateSelection}
      />
    </div>
  )
}

export default MonthView
